import React, { useContext } from "react";
import { TableLegendItem } from "../../models/table/TableLegendItem";
import { ContextToggle } from "./ContextToggle";


export interface LegendContextValueType extends ContextToggle {
    legendItems: TableLegendItem[];
    tableLegendSelectable: Boolean;
    onLegendFilterChange: (newItem: TableLegendItem) => void;
}

export const emptyLegendContextValue = {
    isInUse: false,
    legendItems: [{ value: '', imageIcon: '', label: '', tooltip: '' }],
    tableLegendSelectable: false,
    onLegendFilterChange: () => { },
};

export const LegendContext = React.createContext<LegendContextValueType>(emptyLegendContextValue);

export const useTableLegends = () => {
    return useContext(LegendContext);
};
